import React from 'react';
import AttachmentIcon from './Attachment.icon';
import PictureIcon from './Picture.icon';
import PresentationIcon from './Presentation.icon';
import DocumentIcon from './Document.icon';
import DollarIcon from './Dollar.icon';

const ICON_SIZE = 24;

export const ATTACHMENTS_ICONS: { [key: string]: React.ReactNode } = {
  ['OFFER']: <DollarIcon />,
  ['DOCUMENT']: <DocumentIcon />,
  ['RESUME']: <PresentationIcon />,
  ['PICTURE']: <PictureIcon />,
  ['OTHER']: <AttachmentIcon />,
};

export const ATTACHMENTS_BIG_ICONS: { [key: string]: React.ReactNode } = {
  ['OFFER']: <DollarIcon width={ICON_SIZE} height={ICON_SIZE} />,
  ['DOCUMENT']: <DocumentIcon width={ICON_SIZE} height={ICON_SIZE} />,
  ['RESUME']: <PresentationIcon width={ICON_SIZE} height={ICON_SIZE} />,
  ['PICTURE']: <PictureIcon width={ICON_SIZE} height={ICON_SIZE} />,
  ['OTHER']: <AttachmentIcon width={ICON_SIZE} height={ICON_SIZE} />,
};
